import React from 'react'
import HLTHTEK_ABDM_DEMO from '../../assets/HLTHTEK_ABDM_DEMO.mp4';

function DemoRecording() {
    const handlePlay = () => {
        let vid = document.getElementById("myVideo");
        if (vid.paused) {
            vid.play()
        } else {
            vid.pause()
        }
    }
    return (
        <div style={{ border: "3px solid black" ,padding:'10px'}}>
            <video id="myVideo" src={HLTHTEK_ABDM_DEMO} height={"90%"} width={"90%"} controls="controls" onClick={() => handlePlay()} autoplay="true" type='video/mp4' />
        </div>
    )
}

export default DemoRecording